export const vps = {
  title: 'VPS Hosting',
  subtitle: 'Server VPS ad alte prestazioni con risorse garantite',
  locations: {
    germanyGame: 'Germania (Gaming)',
    germanyPerf: 'Germania (Super Performance)',
    gameDescription: 'AMD Ryzen™ 9 5950X · Ottimizzato per il gaming con prestazioni bilanciate ',
    perfDescription: 'AMD Ryzen™ 9 7950X3D · Prossimamente'
  },
  features: {
    hardware: {
      title: 'Risorse Dedicate',
      description: 'CPU e RAM garantite'
    },
    protection: {
      title: 'Protezione DDoS',
      description: 'Protezione avanzata fino a 4 Tbps'
    },
    storage: {
      title: 'Storage NVMe',
      description: 'Storage SSD ultra veloce'
    }
  },
  comingSoon: {
    title: 'Prossimamente',
    description:
      'La linea “Super Performance” con CPU AMD Ryzen™ 9 7950X3D sarà disponibile a breve. Restiamo al lavoro per offrirti prestazioni di fascia alta.'
  },
  latencyTest: {
    title: 'Test di Latenza',
    startTest: 'Avvia Test',
    testing: 'Test in corso...',
    timeout: 'Timeout',
    average: 'Latenza Media'
  },
  plans: {
    title: 'Piani Disponibili',
    de: {
      game: [
        {
          title: 'Standard Game VPS Nano',
          price: '€2.70',
          specs: [
            '1 vCore',
            '1GB RAM',
            '20GB NVMe',
            'Uplink: 200 Mbps (Fair Use)',
            'Protezione DDoS',
            'Ottimizzato per il Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Micro',
          price: '€5.40',
          specs: [
            '1 vCore',
            '2GB RAM',
            '20GB NVMe',
            'Uplink: 200 Mbps (Fair Use)',
            'Protezione DDoS',
            'Ottimizzato per il Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Lite',
          price: '€7.20',
          specs: [
            '2 vCore',
            '4GB RAM',
            '40GB NVMe',
            'Uplink: 400 Mbps (Fair Use)',
            'Protezione DDoS',
            'Ottimizzato per il Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Boost',
          price: '€9.00',
          specs: [
            '2 vCore',
            '6GB RAM',
            '60GB NVMe',
            'Uplink: 400 Mbps (Fair Use)',
            'Protezione DDoS',
            'Ottimizzato per il Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Turbo',
          price: '€10.80',
          specs: [
            '4 vCore',
            '8GB RAM',
            '80GB NVMe',
            'Uplink: 400 Mbps (Fair Use)',
            'Protezione DDoS',
            'Ottimizzato per il Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Power',
          price: '€14.40',
          specs: [
            '4 vCore',
            '12GB RAM',
            '100GB NVMe',
            'Uplink: 500 Mbps (Fair Use)',
            'Protezione DDoS',
            'Ottimizzato per il Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Pro',
          price: '€21.60',
          specs: [
            '6 vCore',
            '16GB RAM',
            '120GB NVMe',
            'Uplink: 600 Mbps (Fair Use)',
            'Protezione DDoS',
            'Ottimizzato per il Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Max',
          price: '€28.80',
          specs: [
            '6 vCore',
            '24GB RAM',
            '140GB NVMe',
            'Uplink: 800 Mbps (Fair Use)',
            'Protezione DDoS',
            'Ottimizzato per il Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Ultra',
          price: '€37.80',
          specs: [
            '6 vCore',
            '32GB RAM',
            '160GB NVMe',
            'Uplink: 1 Gbps (Fair Use)',
            'Protezione DDoS',
            'Ottimizzato per il Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Hyper',
          price: '€57.60',
          specs: [
            '8 vCore',
            '48GB RAM',
            '200GB NVMe',
            'Uplink: 1 Gbps (Fair Use)',
            'Protezione DDoS',
            'Ottimizzato per il Gaming'
          ]
        }
      ],
      performance: [
        {
          title: 'Super Performance VPS Nano',
          price: '€3.99',
          specs: [
            '1 vCore (AMD Ryzen™ 9 7950X3D)',
            '1GB RAM',
            '10GB NVMe',
            'Uplink: 200 Mbps (Fair Use)',
            'Protezione DDoS',
            'CPU ad Alte Prestazioni'
          ]
        },
        {
          title: 'Super Performance VPS Micro',
          price: '€5.99',
          specs: [
            '2 vCore (AMD Ryzen™ 9 7950X3D)',
            '2GB RAM',
            '20GB NVMe',
            'Uplink: 200 Mbps (Fair Use)',
            'Protezione DDoS',
            'CPU ad Alte Prestazioni'
          ]
        },
        {
          title: 'Super Performance VPS Lite',
          price: '€8.99',
          specs: [
            '2 vCore (AMD Ryzen™ 9 7950X3D)',
            '4GB RAM',
            '40GB NVMe',
            'Uplink: 200 Mbps (Fair Use)',
            'Protezione DDoS',
            'CPU ad Alte Prestazioni'
          ]
        },
        {
          title: 'Super Performance VPS Boost',
          price: '€12.99',
          specs: [
            '4 vCore (AMD Ryzen™ 9 7950X3D)',
            '6GB RAM',
            '60GB NVMe',
            'Uplink: 400 Mbps (Fair Use)',
            'Protezione DDoS',
            'CPU ad Alte Prestazioni'
          ]
        },
        {
          title: 'Super Performance VPS Turbo',
          price: '€15.99',
          specs: [
            '4 vCore (AMD Ryzen™ 9 7950X3D)',
            '8GB RAM',
            '80GB NVMe',
            'Uplink: 400 Mbps (Fair Use)',
            'Protezione DDoS',
            'CPU ad Alte Prestazioni'
          ]
        },
        {
          title: 'Super Performance VPS Power',
          price: '€20.99',
          specs: [
            '6 vCore (AMD Ryzen™ 9 7950X3D)',
            '12GB RAM',
            '100GB NVMe',
            'Uplink: 500 Mbps (Fair Use)',
            'Protezione DDoS',
            'CPU ad Alte Prestazioni'
          ]
        },
        {
          title: 'Super Performance VPS Pro',
          price: '€25.99',
          specs: [
            '6 vCore (AMD Ryzen™ 9 7950X3D)',
            '16GB RAM',
            '120GB NVMe',
            'Uplink: 600 Mbps (Fair Use)',
            'Protezione DDoS',
            'CPU ad Alte Prestazioni'
          ]
        },
        {
          title: 'Super Performance VPS Max',
          price: '€33.99',
          specs: [
            '8 vCore (AMD Ryzen™ 9 7950X3D)',
            '24GB RAM',
            '140GB NVMe',
            'Uplink: 800 Mbps (Fair Use)',
            'Protezione DDoS',
            'CPU ad Alte Prestazioni'
          ]
        },
        {
          title: 'Super Performance VPS Ultra',
          price: '€45.99',
          specs: [
            '8 vCore (AMD Ryzen™ 9 7950X3D)',
            '32GB RAM',
            '160GB NVMe',
            'Uplink: 1 Gbps (Fair Use)',
            'Protezione DDoS',
            'CPU ad Alte Prestazioni'
          ]
        },
        {
          title: 'Super Performance VPS Hyper',
          price: '€65.99',
          specs: [
            '8 vCore (AMD Ryzen™ 9 7950X3D)',
            '48GB RAM',
            '180GB NVMe',
            'Uplink: 1 Gbps (Fair Use)',
            'Protezione DDoS',
            'CPU ad Alte Prestazioni'
          ]
        }
      ]
    }
  }
};
